module.exports = __webpack_public_path__ + "img/C3.0195a166.jpg";